import React, { useContext } from "react";
import _ from "lodash";
import { createUseStyles } from "react-jss";
import { StyleTypeContext } from "../../../umbilical_tools";
import { Panel } from "rsuite";
import PropTypes from "prop-types";
import { TranslationContext } from "../../../umbilical_tools";
import jssVariables from "../../../jss_setup";

const additionalInfoStyles = createUseStyles({
  info: (props) => ({
    display: "grid",
    margin: "5vw",
    marginTop: "10vw",
    "& .rs-panel-body": {
      display: "grid",
      gridGap: jssVariables.normal_gap,
    },
    ..._.get(props, "customStyles.info", {}),
  }),
  header: (props) => ({
    fontSize: "x-large",
    ..._.get(props, "customStyles.additionalInfoHeader", {}),
  }),
  additionalInfoContainer: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    boxShadow: "none",
    "& .rs-panel-body": {
      display: "grid",
      gridGap: jssVariables.normal_gap,
    },
    ..._.get(props, "customStyles.additionalInfoContainer", {}),
  }),
  additionalInfoText: (props) => ({
    ..._.get(props, "customStyles.additionalInfoText", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    info: (props) => ({
      margin: [
        jssVariables.navbar_height,
        jssVariables.spacing.center_margin_large[1],
      ],
      ..._.get(props, "customStyles.info.smallscreen", {}),
    }),
    additionalInfoContainer: (props) => ({
      ..._.get(props, "customStyles.additionalInfoContainer.smallscreen", {}),
    }),
    additionalInfoText: (props) => ({
      padding: 0,
      ..._.get(props, "customStyles.additionalInfoText.smallscreen", {}),
    }),
  },
});
const AdditionalInfo = (props) => {
  const { details, customStyles } = props;
  const { type } = useContext(StyleTypeContext);
  const {
    t,
    i18n: { language },
  } = useContext(TranslationContext);
  const langKey = _.lowerCase(language.split("-")[0]);

  const classes = additionalInfoStyles({
    customStyles,
  });
  var booking_info = "";
  if (details.product_type === "PKG") {
    booking_info = _.get(details, `content.booking_info.${langKey}`, "");
  } else {
    booking_info = _.get(
      details,
      `booking_information.description_${langKey}`,
      ""
    );
  }

  return (
    <React.Fragment>
      {type === "type2" ? (
        <div className={classes.info}>
          <div className={classes.additionalInfoContainer}>
            <span className={classes.header}>{t("information")}</span>
            <div
              className={classes.additionalInfoText}
              dangerouslySetInnerHTML={{ __html: booking_info }}></div>
          </div>
        </div>
      ) : (
        <Panel className={classes.info} shaded>
          <span className={classes.header}>{t("additionalInformation")}</span>
          <div
            className={classes.additionalInfoText}
            dangerouslySetInnerHTML={{ __html: booking_info }}></div>
        </Panel>
      )}
    </React.Fragment>
  );
};
AdditionalInfo.defaultProps = {
  details: {},
  customStyles: {},
};
AdditionalInfo.propTypes = {
  details: PropTypes.object.isRequired,
  customStyles: PropTypes.object.isRequired,
};

export default AdditionalInfo;
